// @ts-nocheck


import React from 'react';

import { ListTable } from '../../../../components/ui';





import { itog, partColumns } from '../elements';

import { sumPartsAndConsumbles } from '../lib';






/**
 * Запчасти и расходные материалы
 */
export default class PartsAndConsumables extends React.Component {
  static defaultProps = {
    detailedDefectiveStatement: null
  };

  render() {
    const { detailedDefectiveStatement } = this.props;
    const data = detailedDefectiveStatement.parts;
    const { sum, sumContractor } = sumPartsAndConsumbles(data);
    return (
      <>
        <ListTable columns={partColumns(undefined, true)} data={data} />
        {itog(sum, sumContractor)}
      </>);

  }
}
